import React, { useEffect, useState } from "react";
import { Button, Container, Row } from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import Header from "../Layout/header";
import Footer from "../Layout/footer";
import { FaArrowRight } from "react-icons/fa6";
import logocircle from "../Assets/logo-circle2.png";
import newsletter from "../Assets/newsletter-image3.png";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import {
  DecryptData,
  HideEmailId,
  NumberChange,
  NumberOnly,
  isEmpty,
  removeLoginToken,
} from "../helper/common";
import {
  ChangeEmailPassword,
  GetuserData,
  userLogin,
} from "../Axios/user.axios";
import config from "../helper/config";
import Subscriber from "../Layout/subscribe";
import { useSelector } from "react-redux";
import OTPInput from "react-otp-input";
import { LogOut } from "../redux/constants";
import { useDispatch } from "react-redux";

const initform = {
  Password: "",
  ConfirmPassword: "",
  EmailId: "",
};

const initname = {
  Password: "Password",
  ConfirmPassword: "Confirm Password",
};

export default function ChangeEmail_Password() {
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();
  const userdata = useSelector((state) => state?.LoginReducer?.User);

  const [passwordType, setPasswordType] = useState("password");
  const [passwordType1, setPasswordType1] = useState("password");
  const [currtoken, SetCurrtoken] = useState("");
  const [focusedfield, SetFocusedField] = useState([]);

  const [formdata, SetFormdata] = useState(initform);
  const [displayname, SetDisplayName] = useState(initname);
  const [Otp, SetOTP] = useState("");
  const [Error, SetError] = useState({});
  const [Type, SetType] = useState("verify");
  const [ChangeType, SetChangeType] = useState(
    location.pathname?.includes("email") ? "email" : "password"
  );
  const [Timer, SetTimer] = useState({
    Minutes: 0,
    Seconds: 0,
  });
  const [counter, setCounter] = useState(180);
  const [Disabled, SetDisabled] = useState(false);
  const [useEffectDisable, SetUseEffectDisable] = useState(false);
  const [DisableStatus, SetDiableStatus] = useState(false);

  useEffect(() => {
    if (!isEmpty(userdata?.payload)) {
      SendOTP();
    }
  }, [userdata?.payload]);

  useEffect(() => {
    let cookie = ("; " + document.cookie)
      .split(`; ${config.cookiename}=`)
      .pop()
      .split(";")[0];
    if (cookie) {
      GetUserProfile(cookie);
    } else {
      navigate("/");
    }
  }, []);

  const GetUserProfile = async (cookie) => {
    if (!DisableStatus) {
      SetDiableStatus(true);
      let resp = await GetuserData({ data: cookie, kyc: false });
      if (resp?.status) {
      } else {
        navigate("/");
      }
      SetDiableStatus(false);
    }
  };

  const SendOTP = async () => {
    if (!useEffectDisable) {
      SetUseEffectDisable(true);
      let Resp = await ChangeEmailPassword({
        EmailId: userdata?.payload?.EmailId,
        type: ChangeType,
        action: "sendotp",
      });
      console.log("ChangeEmailPasswordresp", Resp);
      if (Resp?.status) {
        if (Resp?.data?.RemainingSecond) {
          setCounter(Math.round(NumberChange(Resp?.data?.RemainingSecond)));
        }
        toast.success("OTP sent to " + HideEmailId(userdata?.payload?.EmailId));
      } else {
        toast.error(Resp?.msg);
      }
      // SetUseEffectDisable(false)
    }
  };

  useEffect(() => {
    console.log("vvvvv-->", Type);
    if (Type == "verify") {
      if (counter == 0) {
        SetType("resend");
      }
      const timer =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      const seconds = String(counter % 60).padStart(2, 0);
      const minutes = String(Math.floor(counter / 60)).padStart(2, 0);
      SetTimer({
        Minutes: minutes,
        Seconds: seconds,
      });
      return () => clearInterval(timer);
    }
  }, [counter, Type]);

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const togglePassword1 = () => {
    if (passwordType1 === "password") {
      setPasswordType1("text");
      return;
    }
    setPasswordType1("password");
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    let changetoken = location?.search?.split("?id=")?.[1];
    if (!isEmpty(changetoken)) {
      SetCurrtoken(changetoken);
    }
  }, [location?.search]);

  const OnChange = (e) => {
    const { id, value } = e.target;
    // SetError({})
    SetFormdata({ ...formdata, ...{ [id]: value } });
  };

  const Validate = () => {
    let error = {};
    if (Type == "verify") {
      if (isEmpty("OTP")) {
        error.OTP = "Enter OTP";
      }
    } else if (Type == "change") {
      if (ChangeType == "email") {
        if (isEmpty(formdata?.EmailId)) {
          error.EmailId = "Enter Email-Id";
        } else if (!config.EMAIL.test(formdata.EmailId)) {
          error.EmailId = "Enter Valid Email-Id";
        }
      } else {
        if (isEmpty(formdata?.Password)) {
          error.Password = "Enter Password";
        } else if (!config.PASSWORD.test(formdata?.Password)) {
          error.Password =
            "Password must contain alphanumeric, must contain 8 to 15 letters.";
        }
        if (isEmpty(formdata?.ConfirmPassword)) {
          error.ConfirmPassword = "Enter Confirm Password";
        } else if (formdata?.Password != formdata?.ConfirmPassword) {
          error.ConfirmPassword = "Password and Confirm Password Must be Same.";
        }
      }
    }
    return error;
  };

  const ChangePassword = async () => {
    SetDisabled(true);
    let error = Validate();
    if (isEmpty(error)) {
      let senddata = {};
      if (Type == "verify") {
        senddata.action = "verifyotp";
        senddata.type = ChangeType;
        senddata.OTP = Otp;
        senddata.EmailId = userdata?.payload?.EmailId;
      } else if (Type == "resend") {
        senddata.action = Type;
        senddata.type = ChangeType;
        senddata.EmailId = userdata?.payload?.EmailId;
      } else {
        senddata.action = "change";
        senddata.type = ChangeType;
        senddata.EmailId = userdata?.payload?.EmailId;
        if (ChangeType == "email") {
          senddata.NewEmailId = formdata?.EmailId;
        } else {
          senddata.NewPassword = formdata?.Password;
        }
      }

      var Resp = await ChangeEmailPassword(senddata);
      console.log("ChangeEmailPassword_resp", Resp, senddata);
      if (Resp?.success == "success") {
        toast.success(Resp.msg, 1000);
        if (Type == "resend") {
          setCounter(180);
          SetType("verify");
        } else if (Type == "verify") {
          SetType("change");
        } else if (Type == "change") {
          if (ChangeType != "email") {
            removeLoginToken();
            // if (config.domainname == "localhost") {
            //   document.cookie =
            //     config.cookiename +
            //     "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            // } else {
            //   document.cookie =
            //     config.cookiename +
            //     "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" +
            //     config.domainname +
            //     ";";
            // }
            dispatch({
              type: LogOut,
            });
            navigate("/");
            return
          }

          navigate('/profile')
        }
      } else {
        toast.error(Resp.msg, 1000);
      }
    } else {
      SetError(error);
      toast("Fill the Correct datas", { type: "error" });
    }
    SetDisabled(false);
  };

  const OnBlurFn = (e) => {
    const { id, value } = e.target;
    let error = Validate();
    Object.keys(error).map((currkey) => {
      if (currkey == id || focusedfield.includes(currkey)) {
      } else {
        delete error[currkey];
      }
    });
    if (focusedfield?.includes(id)) {
    } else {
      SetFocusedField([...focusedfield, ...[id]]);
    }
    SetError(error);
  };

  return (
    <>
      <div className="forgotpage">
        <Header />
        {Type == "verify" || Type == "resend" ? (
          <section class="section">
            <div className="container font-md">
              <div className="container text-center customer-reset-password">
                <h2 className="color-brand-1 mb-4">Verification</h2>
                <p className="pr-4">
                  Enter the 6-digit verification code sent to{" "}
                  {HideEmailId(userdata?.payload?.EmailId)}
                </p>
                <form method="POST" class="row" action="">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group position-relative alllogin mb-4">
                      <OTPInput
                        value={Otp}
                        onChange={(e) => SetOTP(NumberOnly(e))}
                        numInputs={6}
                        renderSeparator={<span>-</span>}
                        renderInput={(props) => <input {...props} />}
                        inputStyle={"form-control"}
                        containerStyle={"justify-content-center"}
                      />
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group mb-4">
                        <p className="pr-4">
                          {" "}
                          Otp will expires in{" "}
                          <b>
                            {" "}
                            {Timer.Minutes}:{Timer.Seconds}
                          </b>
                        </p>
                      </div>
                    </div>
                    {Error?.OTP && (
                      <span className="error-msg">{Error.OTP}</span>
                    )}
                  </div>
                  <div class="col-lg-12 mb-5">
                    <button
                      class="btn btn-brand-lg btn-full font-md-bold"
                      type="button"
                      onClick={() => ChangePassword()}
                      disabled={Disabled}
                    >
                      {Type == "verify" ? "Submit" : "ReSend-OTP"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
        ) : (
          <section class="section">
            <div className="container font-md">
              <div className="container text-center customer-reset-password">
                <h2 className="color-brand-1 mb-4">
                  Change {ChangeType == "email" ? "Email-Id" : "Password"}
                </h2>

                                    <form method="POST" class="row" action="">
                                        {
                                            ChangeType == 'email'
                                                ?
                                                <div className="col-lg-12 col-sm-12">
                                                    <div className="form-group position-relative mb-4">
                                                        <input className={focusedfield?.includes('EmailId') ? (Error?.EmailId ? "form-control icon-password is-invalid" : "form-control icon-password is-valid") : "form-control icon-password"} placeholder="Enter Email-Id" type="email" value={formdata?.EmailId || ''} aria-required="true" id='EmailId' onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} />
                                                    </div>
                                                    {Error?.EmailId && <span className="error-msg">{Error.EmailId}</span>}
                                                </div>
                                                :
                                                <>
                                                    <div className="col-lg-12 col-sm-12 mb-4">
                                                        <div className="form-group position-relative">
                                                            <input className={focusedfield?.includes('Password') ? (Error?.Password ? "form-control icon-password is-invalid" : "form-control icon-password is-valid") : "form-control icon-password"} placeholder="New Password" type={passwordType} value={formdata?.Password || ''} aria-required="true" id='Password' onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} />
                                                            <div onClick={togglePassword}>
                                                                {passwordType == "text" ? <FaRegEye className="eyepassword" /> :
                                                                    <FaRegEyeSlash className="eyepassword" />}</div>
                                                        </div>
                                                        {Error?.Password && <p className="error-msg text-start">{Error.Password}</p>}
                                                    </div>
                                                    <div className="col-lg-12 col-sm-12 mb-4">
                                                        <div className="form-group position-relative">
                                                            <input className={focusedfield?.includes('ConfirmPassword') ? (Error?.ConfirmPassword ? "form-control icon-password is-invalid" : "form-control icon-password is-valid") : "form-control icon-password"} placeholder="Confirm Password" type={passwordType1} value={formdata?.ConfirmPassword || ''} aria-required="true" id='ConfirmPassword' onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} />
                                                            <div onClick={togglePassword1}>
                                                                {passwordType1 == "text" ? <FaRegEye className="eyepassword" /> :
                                                                    <FaRegEyeSlash className="eyepassword" />}</div>
                                                        </div>
                                                        {Error?.ConfirmPassword && <p className="error-msg text-start">{Error.ConfirmPassword}</p>}
                                                    </div>
                                                </>
                                        }
                                        <div class="col-lg-12 mb-5">
                                            <button class="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={() => ChangePassword()} disabled={Disabled} >Change { ChangeType == 'email' ? "Email-Id" : "Password" }</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
              
            )}

        <Subscriber />
        {/* <div className="box-newsletter">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 mt-3 col-md-12">
                                <div className="box-image-newsletter">
                                    <div className="">
                                        <img className="img-main" src={newsletter} alt="Image NewsLetter" />
                                        <div className="shape-2 image-1"><img src={logocircle} alt="Icon primary" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mt-3">
                                <span className="font-lg color-brand-1">Newsletter</span>
                                <h2 className="color-brand-1 mt-2 mb-15">Subscribe our newsletter</h2>
                                <p className="font-md color-grey-500">By clicking the button, you are agreeing with our Term & Conditions</p>
                                <div className="form-newsletter mt-3 position-relative">
                                    <form action="" className="newsletter-form" novalidate="novalidate">
                                        <input type="email" name="email" placeholder="Enter your email..." />
                                        <button className="btn btn-submit-newsletter" type="submit">
                                            <FaArrowRight />
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

        <Footer />
      </div>
    </>
  );
}
